"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleType = void 0;
var ModuleType;
(function (ModuleType) {
    ModuleType["Standard"] = "main";
    ModuleType["Extra"] = "add_on";
    ModuleType["Paid"] = "paid_add_on";
})(ModuleType || (exports.ModuleType = ModuleType = {}));
